import React, { useState } from "react";
import { Link } from "react-router-dom";
import SmilingMan from "../Assets/Images/purchase-life-img-new.png";
import TealAccordianArrowDown from "../Assets/Images/TealArrowIcon.svg";
import CapsuleImageVertical from "./CapsuleImageVertical/CapsuleImageVertical";
import { useTranslation } from "../Hooks/useTranslation"; // Import the hook
import "../Assets/Styles/HealthInsurance.css";

const HealthInsuranceHero = ({ pageName = null }) => {
  const translations = useTranslation(); // Get translations dynamically

  const [openModalIndex, setOpenModalIndex] = useState(null);

  const benefits = [
    {
      title: translations.provenExperience,
      description: translations.provenExperienceDescription,
      color: "border-[#53BCC8]",
    },
    {
      title: translations.flexibleProducts,
      description: translations.flexibleProductsDescription,
      color: "border-[#AFA07B]",
    },
    {
      title: translations.lastingCommitment,
      description: translations.lastingCommitmentDescription,
      color: "border-[#0D4248]",
    },
    {
      title: translations.prestige,
      description: translations.PrestigeDescription,
      color: "border-[#AFA07B]",
    },
  ];

  return (
    <div className="healthInsurance-section py-[6rem] lg:py-[6rem] md:py-[8rem]  bg-[#FAFAFA]">
      <div className="container healthinsurancemaindiv default-container">
        <div className="insurance-section items-center lg:pl-0 md:pl-2">
          {/* Left Section */}
          <div className="">
            <div className="max-w-[25rem] upperdivwhyaquire reveal-up mt-12 md:mt-0 lg:pl-7">
              <h1
                className="text-xl md:!text-[28px] md:!leading-[32px] md:!tracking-[-0.56px] xl:!text-[40px] xl:!leading-[44px] xl:!tracking-[-0.8px] [@media(min-width:1920px)]:!text-[60px] [@media(min-width:1920px)]:!leading-[78px] [@media(min-width:1920px)]:!tracking-[-1.2px] text-left lg:text-left font-bold lg:mb-4 text-black whyacqtext extra-title-heading"
                dangerouslySetInnerHTML={{
                  __html: translations.WhyChooseHeading,
                }}
              ></h1>
              <div className="lg:block hidden">
                <p className="text-gray-600 mb-8 text-sm md:!text-[11.5px] md:!leading-[18px] xl:!text-[14px] xl:!leading-[22px] [@media(min-width:1920px)]:!text-[21px] [@media(min-width:1920px)]:!leading-[32px] whydesc extra-para-vs">
                  {translations.WhyChooseDescription}
                </p>
              </div>
            </div>
            {/* Mobile View - Modal Trigger Buttons */}
            <div className="col3 block lg:hidden reveal-up pt-0 pr-0 mt-5">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex flex-col mb-4">
                  <button
                    onClick={() => setOpenModalIndex(index)}
                    className={`flex self-start font-semibold justify-center items-center w-auto px-4 py-2 rounded-full text-sm font-medium border transition-colors duration-200 text-black ${benefit.color}`}
                  >
                    <div>{benefit.title}</div>
                    <img
                      src={TealAccordianArrowDown}
                      alt="Modal Trigger Icon"
                      className="ms-2"
                    />
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Center Image Section */}
          <div className="col2 relative">
            <CapsuleImageVertical image={SmilingMan} />
          </div>

          {/* Right Section */}
          <div className="col3 hidden lg:block">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className={`flex flex-col mb-8 mt-8 pl-8 reveal-up reveal-delay-${index + 1}`}
              >
                <h3
                  className="text-sm md:!text-[12px] md:!leading-[16px] xl:!text-[16px] xl:!leading-[22px] [@media(min-width:1920px)]:!text-[24px] [@media(min-width:1920px)]:!leading-[33px] font-bold text-black benefitstitle mb-2 extra-title24"
                  dangerouslySetInnerHTML={{ __html: benefit.title }}
                ></h3>
                <p
                  className="text-gray-600 text-xs md:!text-[11.5px] md:!leading-[18px] xl:!text-[14px] xl:!leading-[22px] [@media(min-width:1920px)]:!text-[21px] [@media(min-width:1920px)]:!leading-[32px] benefitsdesc extra-para-vs"
                  dangerouslySetInnerHTML={{ __html: benefit.description }}
                ></p>
              </div>
            ))}
          </div>
        </div>

        {openModalIndex !== null && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
            onClick={() => setOpenModalIndex(null)}
          >
            <div
              className="relative bg-white py-10 px-6 rounded-3xl shadow-2xl w-[300px] max-w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setOpenModalIndex(null)}
                className="absolute top-6 right-8"
              >
                ✖
              </button>
              <p
                className=" font-bold mb-4 mt-2 "
                dangerouslySetInnerHTML={{
                  __html: benefits[openModalIndex].title,
                }}
              ></p>
              <p
                className="text-gray-600 text-xs mb-5"
                dangerouslySetInnerHTML={{
                  __html: benefits[openModalIndex].description,
                }}
              ></p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HealthInsuranceHero;
